'use client';

import { CarouselDesktopActiveFeature } from './CarouselDesktopActiveFeature';
import { CarouselDesktopNav } from './CarouselDesktopNav';
import { Feature } from './TabbedAnimatedCarousel';
import { useDesktopCarousel } from './TabbedAnimatedCarousel.hooks';

export type DesktopCarouselProps = {
  features: Feature[];
}

export const DesktopCarousel = ({ features }: DesktopCarouselProps) => {
  const { activeFeatureIndex, activeFeature, updateActiveFeatureIndex } = useDesktopCarousel({ features });

  return (
    <>
      <CarouselDesktopNav features={features} activeFeatureIndex={activeFeatureIndex} onClick={updateActiveFeatureIndex} />
      <CarouselDesktopActiveFeature activeFeature={activeFeature} />
    </>
  )
}
